import React from "react";
import { Box, Typography, Switch, styled } from "@mui/material";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 39,
  height: 20,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 16,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(19px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(19px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#1890ff",
        opacity: 1,
        border: 0,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 16,
    height: 16,
    borderRadius: 16 / 2,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 20 / 2,
    opacity: 1,
    backgroundColor: "#E9E9EA",
    boxSizing: "border-box",
  },
}));

const UsersActive = ({ label, value, checked, onToggle, sx }) => {
  return (
    <Box
      sx={{
        boxShadow: "1.5px 2.6px 10px 0px #7777771A",
        width: "100%",
        height: "193px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        ...sx,
      }}
    >
      <Typography fontSize="35px" fontWeight="700" color="primary">
        {value}
      </Typography>

      <Typography fontSize="18px" fontWeight="500" color="#464A53">
        Users Active: {label}
      </Typography>

      <AntSwitch checked={checked} onChange={onToggle} />
    </Box>
  );
};

export default UsersActive;
